/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Dictionary, TextDictionary } from '@gh/common-shared';
import { mapKeys } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { FormulaNameResolver, StaticFormulaNameResolver } from './parser';
import { FormulaVariable } from './parser/formula-name-resolver';

export class FormulaContext {
  private _nameResolver: StaticFormulaNameResolver;
  private _stateChanges = new Subject<void>();
  private _variables: Hash<FormulaVariable>;

  constructor(readonly groups: Dictionary<any>,
              variables: Hash<FormulaVariable>,
              functions: Hash<{ argCount: number | number[] }>,
              readonly errorBundle: TextDictionary,
              private snippets: Hash<string[]>) {
    this._variables = variables;

    this._nameResolver = new StaticFormulaNameResolver({
      variables: mapKeys(variables, 'name'),
      functions,
    });
  }

  get nameResolver(): FormulaNameResolver {
    return this._nameResolver;
  }

  get variables(): Hash<FormulaVariable> {
    return this._variables;
  }

  get stateChanges(): Observable<void> {
    return this._stateChanges.asObservable();
  }

  getSnippets(group: string): string[] {
    return this.snippets[group];
  }

  setSnippets(group: string, snippets: string[]): void {
    this.snippets[group] = snippets;
    this._stateChanges.next();
  }

  setVariables(variables: Hash<FormulaVariable>): void {
    this._variables = variables;
    this._nameResolver.setVariables(mapKeys(variables, 'name'));
    this._stateChanges.next();
  }
}
